import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tan',
  templateUrl: './tan.component.html',
  styleUrls: ['./tan.component.scss']
})
export class TanComponent implements OnInit {
  public imagePath;
  imgURL: any;
  showScore: boolean = false;
  public message: string;
  constructor() { }

  ngOnInit() {
  }

  preview(files) {
    if (files.length === 0)
      return;
 
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }
 
    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]); 
    reader.onload = (_event) => { 
      this.imgURL = reader.result; 
    }
  }

  toggleScore() {
    this.showScore = !this.showScore
  }

}
